import { BASE_PATH } from "@/generated/base";
import { useViewMode } from "@/hooks/useViewMode";
import globalAxios from "axios";
import buildQuery from "odata-query";
import { message } from "./common";
import * as crypto from "crypto-js";
import { loginWechatRedirect } from "@/pagesMp/hook/useWechatPublic";

// const server_url = location.origin + '/api/standard';
// const server_url = import.meta.env.VITE_SERVER_URL;
const { isPc } = useViewMode();

function errorHandler(res: any) {
  const data = res.data;
  let errMsg: string | undefined;

  if (res.data?.isSuccess === false) {
    errMsg = res.data?.message;
  } else if (/@odata/.test(data)) {
    // odata 数据返回不完整
    errMsg = "odata 返回数据不完整";
  } else if (data.code === "Fail") {
    errMsg = data.message;
  } else if (data?.data?.errmsg) {
    errMsg = data?.data?.errmsg;
  }

  if (errMsg) {
    const customShowErrorMsg = res?.config?.showErrorMsg;
    if (customShowErrorMsg) {
      customShowErrorMsg(res.data?.message);
    } else {
      message.error(res.data?.message);
    }
    throw new Error(errMsg);
  }
}
let Inc = new Date().getTime();
globalAxios.interceptors.request.use((config: any) => {
  config.headers["Access-Control-Allow-Origin"] = "*";

  const token = localStorage.getItem("token");

  if (token && !config.headers["authorization"]) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // if (server_url) {
  //   config.url = config.url?.replace(BASE_PATH, server_url);
  // }
  // Inc += 1;
  // if (config.params) {
  //   config.params._ = Inc;
  // } else {
  //   config.params = {
  //       _: Inc
  //   };
  // }
  if (config?.odata) {
    if (typeof config?.odata === "object") {
      config.odata = buildQuery(config?.odata);
    }
    config.url += config?.odata;
  }
  if (window.location.origin.indexOf("localhost") == -1) {
    // config.url = import.meta.env.VITE_SERVER_ORIGIN + config.url;
    config.url = window.location.origin + config.url;
  }
  // console.log(config, import.meta.env.VITE_SERVER_URL, "config after");

  // 对odata接口调用进行加密
  const url = config.url.toLowerCase();
  if (url.includes("/api/standard/")) {
    const seed = localStorage.getItem("seed");

    if (seed) {
      let urlSplit = config.url.split("/standard/");
      let ajaxData = crypto.TripleDES.encrypt(
        urlSplit[1],
        crypto.enc.Utf8.parse(seed.substring(0, 24)),
        { mode: crypto.mode.ECB }
      ).toString();
      let request = encodeURIComponent(ajaxData);
      config.url = "/api/gateway/standard?request=" + request;
    } else {
      // if (!url.includes("/api/standard/odata/cnfsettings")) {
      //   expiredRedirect();
      // }
      // console.log(config, window.location.href, "request config redirect");
    }
  }

  return config;
});

// 返回拦截
globalAxios.interceptors.response.use(
  (res: any) => {
    errorHandler(res);
    // console.log("response: ", res);
    // odata返回数据
    if (res.data.value) {
      if (res.data["@odata.count"] > -1) {
        res.count = res.data["@odata.count"];
      }
      res.resData = res.data;
      res.data = res.data.value;
    } else {
      // 其他返回
      res.count = res.data["data_count"];
      res.resData = res.data;
      // res.data = res.data.data;
    }
    // if (res.data["data_count"] > -1) {
    // }
    return res;
  },
  (err) => {
    // 登录过期，跳转登录
    if (err.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("userinfo");
      localStorage.removeItem("seed");
      expiredRedirect();
      throw err;
    }

    console.error(err, "reject err");
    message.error(err?.message);
    throw err;
    // alert(
    //   err.config?.url +
    //     ":   " +
    //     err.message +
    //     " " +
    //     err.response.data?.slice(0, 100)
    // );
    // throw new Error(err);
    return err;
  }
);

// 登录失效重定向页面
function expiredRedirect() {
  const whiteList = [
    "/auth-test",
    "/admin",
    "/authorize",
    "/login",
    "/meeting-detail",
    "/register",
    "/checkin",
    "/loginScan",
  ];
  if (whiteList.find((i) => window.location.href.includes(i))) {
    return;
  }

  // 微信环境过期自动重新登录
  if (/micromessenger/i.test(navigator.userAgent)) {
    return loginWechatRedirect();
  }

  if (isDev) {
    window.location.href = window.location.origin + '/pages/auth-test/index';
    return
  }

  const loginExpiredPath = isPc
    ? "/pages/loginScan/index"
    : "/pagesMp/login-expired/index";
  if (!window.location.href.includes(loginExpiredPath)) {
    window.location.href = window.location.origin + loginExpiredPath;
  }
}
